<template>
	<section class="section-base form-section-base mt-5">
		<div :class="`${statementType === StatementType.NOTICE_RECOVERY ? 'form-section-base__block-outer' : ''}`">
			<div :class="`${statementType === StatementType.NOTICE_RECOVERY ? 'form-section-base__block-inner' : ''}`">
				<template v-if="canSelectRegion">
					<div class="form-section-base__title">
						{{
							statementType === StatementType.NOTICE_RECOVERY
								? 'Сведения о месте совершения нотариального действия'
								: 'Выбор места совершения нотариального действия'
						}}
					</div>

					<MapElement
						@region-code-change="$v.regionCode.$model = $event"
						@district-id-change="districtId = $event"
						:region-code="$v.regionCode.$model"
						:district-id="districtId"
						:disabled="isAlternativeServiceEdit"
						:error-messages="getValidationErrorText($v.regionCode)"
						:error-message-district="getValidationErrorText($v.districtId)"
						:statement-type="statementType"
					/>
				</template>
				<slot></slot>
			</div>
		</div>
		<div class="form-base__footer">
			<v-container>
				<v-row>
					<v-col>
						<div class="button-box justify-space-between">
							<div>
								<v-btn
									depressed
									color=""
									class="button-base-white"
									@click="nextStep"
								>Просмотреть заявление
								</v-btn>
								<v-btn
									depressed
									color=""
									:disabled="!xmlFileURL"
									:href="getFileLink(xmlFileURL)"
									class="button-base-white ml-5"
								>Скачать заявление
								</v-btn>
							</div>
							<div>
								<v-btn
									@click="prevStep"
									:loading="loadingNext"
									:disabled="loadingNext || isNavigationDisabled"
									depressed
									color="primary"
									class="button-base"
								>Назад
								</v-btn>

								<router-link
									v-if="saveBtnIsVisible"
									:to="{ name: RouteName.HOME }"
								>
									<v-btn depressed color="primary" class="button-base ml-5">
										Сохранить
									</v-btn>
								</router-link>
								<v-btn
									v-else
									depressed
									color="primary"
									class="button-base ml-5"
									:loading="loadingNext"
									:disabled="loadingNext || isNavigationDisabled"
									@click="nextStepSign"
								>
									{{ textButtonSign }}
								</v-btn>
							</div>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</section>
</template>

<script>
import {mdiAlertCircleOutline} from '@mdi/js';
import {required, requiredIf} from 'vuelidate/lib/validators';

import {ServicesModule} from '@/store/modules/services';
import {getFileLink} from '@/api/filestorage';
import {RouteName} from '@/router';
import {MutationType, StatementType, StepDirection} from '@/types/services';
import {statementTypeToIsTestMode} from '@/app.config';
import MapElement from '@/components/services/elements/MapElement';
import {MapModule} from '@/store/modules/map';
import {getValidationErrorText} from '@/utils/validate';

export default {
	name: 'StepSign',
	props: {
		loadingNext: {
			type: Boolean,
			required: true,
		},
		statementType: {
			type: String,
			required: true,
		},
		isAlternativeServiceEdit: {
			type: Boolean,
		},
		isNavigationDisabled: {
			type: Boolean,
		},
		withAdditionalSigners: {
			type: Boolean,
		},
	},
	components: {MapElement},
	data: () => ({
		StatementType,
		RouteName,
		mdiAlertCircleOutline,
		getValidationErrorText,
		getFileLink,
		ServicesModule,
		xmlFileURL: '',
		unsubscribe: null,

		regionCode: null,
		districtId: null,
	}),

	validations: {
		regionCode: {
			required,
		},
		districtId: {
			required: requiredIf(function () {
				return this.isAcceptanceDeposit && !this.isFederalCity
			})
		}
	},

	created() {
		this.unsubscribe = this.$store.subscribe((mutation) => {
			if (mutation.type === MutationType.SET_STATEMENT_XML) {
				this.xmlFileURL = ServicesModule.statement?.xmlFileLink;
			}
		});

		if (this.isAlternativeServiceEdit) {
			this.prefillDraft();

			if (!this.xmlFileURL) {
				this.xmlFileURL = ServicesModule.statement?.xmlFileLink;
			}
		}
	},

	beforeDestroy() {
		this.unsubscribe();
	},

	computed: {
		StatementType() {
			return StatementType
		},
		saveBtnIsVisible() {
			return statementTypeToIsTestMode[this.statementType];
		},

		textButtonSign() {
			return this.withAdditionalSigners ? 'Отправить' : 'Подписать и отправить';
		},

		canSelectRegion() {
			return this.statementType !== StatementType.ROD;
		},

		districts() {
			return MapModule.districts.entity;
		},

		selectedDistrict() {
			return this.districts.find(
				(district) => district.districtId === this.districtId
			);
		},

		isAcceptanceDeposit() {
			return this.statementType === StatementType.ACCEPTANCE_DEPOSIT;
		},

		isFederalCity() {
			return ['77', '78', '92'].includes(this.regionCode);
		},
	},

	methods: {
		prefillDraft() {
			const locationStep = ServicesModule.statement.locationStep;

			this.regionCode = locationStep.regionCode;
			this.districtId = locationStep.districtId || null;
		},

		nextStep() {
			this.$emit(StepDirection.NEXT, {
				fragment: {},
				step: '',
			});
		},

		prevStep() {
			this.$emit(StepDirection.PREV, {
				fragment: {},
				step: '',
			});
		},

		nextStepSign() {
			if (!this.canSelectRegion) {
				this.$emit('nextSign');
				return;
			}

			this.$v.$touch()

			if (this.$v.$invalid) {
				this.$vuetify.goTo('#scroll-target', {duration: 100});
			} else {
				ServicesModule.setDistrictRegion({
					regionCode: this.regionCode,
					districtId: this.districtId,
					chamberId: this.selectedDistrict?.chamberId || null,
				});
				this.$emit('nextSign');
			}
		},
	},
};
</script>

<style scoped lang="scss">
.form {
	margin-top: 30px;
}
</style>
